var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-0"},[_c('div',{staticClass:"rw-choose-correct-answer"},[(_vm.value.label1)?_c('text-input',{staticClass:"h5",attrs:{"value":_vm.value.label1.data}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }